var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgEyeoffreact = function SvgEyeoffreact(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#657077",
    fillRule: "evenodd",
    d: "M11.962 1.451 2.3 14.205l1.594 1.207L13.556 2.66zM8 4q.188 0 .374.02l1.334-1.76A5.9 5.9 0 0 0 8 2c-1.888 0-3.543.97-4.777 1.994-1.25 1.037-2.195 2.233-2.68 2.905a1.87 1.87 0 0 0 0 2.201 17 17 0 0 0 2.14 2.432l1.215-1.603a15 15 0 0 1-1.683-1.93c.449-.612 1.257-1.613 2.285-2.466C5.584 4.633 6.79 4 8 4m-1.521 9.793c.486.131.994.207 1.521.207 1.888 0 3.543-.97 4.778-1.995 1.25-1.037 2.194-2.233 2.68-2.905a1.87 1.87 0 0 0 0-2.2 17 17 0 0 0-2.008-2.308l-1.217 1.606c.68.668 1.216 1.343 1.552 1.802-.449.612-1.257 1.613-2.284 2.466C10.416 11.366 9.209 12 8 12q-.08 0-.16-.004z",
    clipRule: "evenodd"
  })));
};
export default SvgEyeoffreact;